import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import AdminPagination from '../Pagination';
import AdminResultsPerPageSelector from '../ResultsPerPageSelector';

class AdminFileSizesFooter extends PureComponent {
  render() {
    const {
      sizesTotal,
      page,
      perPage,
      handleChangePage,
      handleChangePerPage,
    } = this.props;

    return (
      <div className="table-footer">
        <AdminResultsPerPageSelector
          perPage={perPage}
          handleChangePerPage={handleChangePerPage}
        />
        <AdminPagination
          total={sizesTotal}
          page={page}
          perPage={perPage}
          handleChangePage={handleChangePage}
        />
      </div>
    );
  }
}

AdminFileSizesFooter.propTypes = {
  sizesTotal: PropTypes.number.isRequired,
  page: PropTypes.number.isRequired,
  perPage: PropTypes.number.isRequired,
  handleChangePage: PropTypes.func.isRequired,
  handleChangePerPage: PropTypes.func.isRequired,
};

export default AdminFileSizesFooter;
